<svg xmlns="http://www.w3.org/2000/svg" [attr.width]="this.size" [attr.height]="this.size * 1.25"
  [attr.viewBox]="'0 0 ' + width + ' ' + height">

  <g *ngIf="debug">
    <defs>
      <pattern id="smallGrid" width="10" height="10" patternUnits="userSpaceOnUse">
        <path d="M 10 0 L 0 0 0 10" fill="none" stroke="gray" stroke-width="0.5" />
      </pattern>
      <pattern id="grid" width="100" height="100" patternUnits="userSpaceOnUse">
        <rect width="100" height="100" fill="url(#smallGrid)" />
        <path d="M 100 0 L 0 0 0 100" fill="none" stroke="gray" stroke-width="1" />
      </pattern>
    </defs>
    <rect width="100%" height="100%" fill="url(#grid)" />
  </g>

  <svg class="header">
    <text class="title" x="10" y="20">{{base}} x {{columns}}</text>
    <text class="installation-base" [attr.x]="width / 2" y="20">{{properties.installation_base}}</text>
    <text class="diameters" [attr.x]="width - 100" y="20" i18n>Duct {{properties.duct_diameter}} mm</text>
    <text class="diameters" [attr.x]="width - 100" y="35" i18n>Subduct {{properties.subduct_diameter}} mm</text>
  </svg>

  <svg class="base" *ngFor="let base of properties.ducts; let line = index" [attr.x]="line * 100"
    [attr.y]="headerHeight">
    <svg class="column" *ngFor="let duct of base; let column = index" [attr.y]="column * 100">
      <g app-edge-duct-diagram-duct [duct]="duct"></g>
      <text class="duct-label" text-anchor="end" x="100" y="100">{{line + 1}}-{{column + 1}}</text>
    </svg>
  </svg>

  <svg class="footer" [attr.x]="width - 200" [attr.y]="height - footerHeight + 10">
    <rect class="border" width="200" height="40"></rect>

    <circle class="subduct" cx="20" cy="20" r="10"></circle>
    <text class="free" x="40" y="25" i18n>Free</text>

    <circle class="subduct occupied" cx="100" cy="20" r="10"></circle>
    <text class="occupied" x="120" y="25" i18n>Occupied</text>
  </svg>

  <style>
    text {
      font: bold 12px 'Courier New', Courier, monospace;
      fill: white;
    }

    .header .title {
      font-size: 14px;
    }

    .header .installation-base {
      text-anchor: middle;
    }

    .header,
    .footer {
      text-shadow: 1px 1px 2px black;
    }

    circle.duct {
      stroke-width: 4px;
      filter: drop-shadow(3px 5px 2px rgb(0 0 0 / 0.4));
    }

    circle.subduct {
      stroke-width: 2px;
    }

    circle.duct,
    circle.subduct {
      stroke: #156470;
      fill: #5dd3f1;
    }

    circle.duct.occupied,
    circle.subduct.occupied {
      stroke: #a55362;
      fill: #e2acb6;
    }

    text.duct-label {
      text-shadow: 1px 1px 2px black;
    }

    text.subduct-label {
      fill: #156470;
      text-anchor: middle;
    }

    text.subduct-label.occupied {
      fill: #a55362;
    }

    .footer circle {
      filter: drop-shadow(3px 5px 2px rgb(0 0 0 / 0.4));
    }

    .footer .border {
      stroke: white;
      stroke-dasharray: 2 2;
      fill: none;
    }
  </style>
</svg>

<pre *ngIf="debug">
  width: {{width}}
  height: {{height}}
  scale: {{scale}}
</pre>
